<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Устройства</div>
        </div>
    </div>
    <div ref="devicesTable" class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input @keyup.delete="onDeleteSearchByNumberPharmacy()" @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
            <button @click="onSearch" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                          stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
            <v-select
                v-model="deviceType"
                :items="deviceTypes"
                @update:modelValue="onChangeDeviceType"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                label="Тип устройства"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        <a class="title-block__btn btn-info btn-outline-primary btn a-modal" @click="showModal = true">Отсутствует устройство?</a>
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
                <th v-for="elem in thead">{{ elem }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tbody">
                <td>
                    <div class="marker marker_16px bg-red" v-bind:class="{'bg-green': row.tbody.status == 1}" v-bind:title="row.tbody.status_title"></div>
                </td>
                <td>{{ row.tbody.pharmacy_number }}</td>
                <td>{{ row.tbody.address }}</td>
                <td>{{ row.tbody.type }} {{ row.tbody.item }}</td>
                <!-- Столбец для Плейлистов / групп
                <td>
                    <div style="display: flex; gap: 12px;">
                        <div class="table-popup-btn" @click="showPlaylistsModal">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.5 12.5H5C4.33696 12.5 3.70107 12.2366 3.23223 11.7678C2.76339 11.2989 2.5 10.663 2.5 10M2.5 10V5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H10C10.663 2.5 11.2989 2.76339 11.7678 3.23223C12.2366 3.70107 12.5 4.33696 12.5 5V7.5M2.5 10L4.41333 8.0867C4.78996 7.71013 5.30074 7.49858 5.83333 7.49858C6.36592 7.49858 6.87671 7.71013 7.25333 8.0867L7.5 8.33336M5.83333 5V5.00833M7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5H15C15.663 7.5 16.2989 7.76339 16.7678 8.23223C17.2366 8.70107 17.5 9.33696 17.5 10V15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5H10C9.33696 17.5 8.70107 17.2366 8.23223 16.7678C7.76339 16.2989 7.5 15.663 7.5 15V10ZM11.6667 11.25V13.75L13.75 12.5L11.6667 11.25Z" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>6</span>
                        </div>
                        <div class="table-popup-btn" @click="showDeviceGroupsModal">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.1667 14.1666V15.8333C14.1667 16.2753 13.9911 16.6992 13.6785 17.0118C13.366 17.3243 12.942 17.4999 12.5 17.4999H4.16667C3.72464 17.4999 3.30072 17.3243 2.98816 17.0118C2.67559 16.6992 2.5 16.2753 2.5 15.8333V8.33325C2.5 7.89122 2.67559 7.4673 2.98816 7.15474C3.30072 6.84218 3.72464 6.66659 4.16667 6.66659H5.83333M7.5 3.33325H10L11.6667 4.99992H15.8333C16.2754 4.99992 16.6993 5.17551 17.0118 5.48807C17.3244 5.80063 17.5 6.22456 17.5 6.66659V12.4999C17.5 12.9419 17.3244 13.3659 17.0118 13.6784C16.6993 13.991 16.2754 14.1666 15.8333 14.1666H7.5C7.05797 14.1666 6.63405 13.991 6.32149 13.6784C6.00893 13.3659 5.83333 12.9419 5.83333 12.4999V4.99992C5.83333 4.55789 6.00893 4.13397 6.32149 3.82141C6.63405 3.50885 7.05797 3.33325 7.5 3.33325Z" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>12</span>
                        </div>
                    </div>
                </td> -->
                <td>
                    <button v-if="row.tbody.license_key" class="copy-btn reset-btn" v-on:click="copyKey($event)" type="button">
                        {{ row.tbody.license_key }}
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>

    <!-- Модалка для Плейлистов / групп
    <PlaylistsAndGroupsModal
        v-if="showPlaylistsAndGroupsModal"
        :modalTitle="modalTitle"
        :items="modalItems"
        @closeModal="closePlaylistAndGroupsModal"
    /> -->

    <!-- Модальное окно -->
    <div v-if="showModal" class="modal-overlay">
        <div class="modal-container">
            <div class="modal-header">
                <h5 style="padding: 16px;" class="modal-title w-100">Сообщите об отсутствующем устройстве</h5>
            </div>
            <div class="modal-body">
                <div>
                    <div class="modal-text">Если вы заметили, что в системе отсутствует какое-либо устройство, то, пожалуйста, введите номер аптеки и отметьте нужное устройство</div>
                    <label class="form-label">Номер аптеки <span class="color-red">*</span></label>
                    <input class="form-control modal-input"
                           type="text"
                           v-model="missingStore"
                           placeholder="Введите номер аптеки"
                           @input="validateMissingStore">
                </div>
                <div class="modal-radio-btns">
                    <label class="form-label">Тип устройства <span class="color-red">*</span></label>
                    <div v-for="type in deviceTypes" class="form-check">
                        <input class="form-check-input" type="radio" :value="type.id" v-model="missingType" :id="'flexRadioDefault' + type.id">
                        <label class="form-check-label" :for="'flexRadioDefault' + type.id">{{ type.name }}</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-lg btn-primary" @click="closeModal">
                    Отправить
                </button>
                <button type="button" class="btn btn-lg btn-outline-dark" @click="this.showModal = false">
                    Отменить
                </button>
            </div>
        </div>
    </div>
    <Alert />
</template>

<script>
import {withPopper} from '../../../../utilites';
import Device from '../../../../models/Device'
import ChangePage from '../../../../helpers/ChangePage'
import PaginationElement from '../../../../elements/PaginationElement.vue'
import PlaylistsAndGroupsModal from '../../../../modals/PlaylistsAndGroupsModal.vue';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'DevicesListClientComponent',
    components: {
        Alert,
        PaginationElement,
        PlaylistsAndGroupsModal
    },
    props: {
        route_list: String,
        route_get_names_devices_types: String,
        route_device_missing: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            deviceType: null,
            deviceTypes: [],
            missingType: '',
            missingStore: '',
            missingTypes: [],
            device: new Device({
                route_list: this.route_list,
            }),
            selected_device_type: null,
            search: '',
            actions: [],
            thead: [
                'Статус', '№ аптеки', 'Адрес', 'Тип и №', 'Ключ лицензии',
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
            searchNumberPharmacy: '',
            license_key: '',
            showModal: false,
            showPlaylistsAndGroupsModal: false,

            modalTitle: '',
            modalItems: [],

            playlists: [
                {id: 1, name: 'Столички_ноябрь_2023'},
                {id: 2, name: 'Столички_ТВ'},
                {id: 3, name: 'Столички_ТВ'},
                {id: 4, name: 'ТВ_2024_Миллион призов'},
                {id: 5, name: 'ТВ_2024_Миллион призов'},
                {id: 6, name: 'ТВ_2024_Миллион призов'},
                {id: 7, name: 'ТВ_2024_Миллион призов'},
                {id: 8, name: '07_24_ТВ_Столички'},
                {id: 9, name: 'Столички_ноябрь_2023'},
                {id: 10, name: 'Столички_ноябрь_2023'},
                {id: 11, name: 'Столички_ТВ'},
                {id: 12, name: 'Столички_ТВ'},
                {id: 13, name: 'Столички_ТВ'},
                {id: 14, name: 'Столички_ТВ'},
                {id: 15, name: 'Столички_ноябрь_2023'},
                {id: 16, name: 'Столички_ТВ'},
                {id: 17, name: 'Столички_ТВ'},
                {id: 18, name: 'Столички_ТВ'},
                {id: 19, name: '07_24_ТВ_Столички'},
                {id: 20, name: 'Столички_ТВ'},
                {id: 21, name: 'Столички_ТВ'},
            ],
            deviceGroups: [
                {id: 1, name: 'Столички_МСК'},
                {id: 2, name: 'Столички_ТВ'},
                {id: 3, name: 'Столички_ТВ'},
                {id: 4, name: 'ТВ_2024_Миллион призов'},
                {id: 5, name: 'ТВ_2024_Миллион призов'},
                {id: 6, name: 'ТВ_2024_Миллион призов'},
                {id: 7, name: 'ТВ_2024_Миллион призов'},
                {id: 8, name: '07_24_ТВ_Столички'},
                {id: 9, name: 'Столички_МСК'},
                {id: 10, name: 'Столички_МСК'},
                {id: 11, name: 'Столички_ТВ'},
                {id: 12, name: 'Столички_ТВ'},
                {id: 13, name: 'Столички_ТВ'},
                {id: 14, name: 'Столички_ТВ'},
                {id: 15, name: 'Столички_МСК'},
                {id: 16, name: 'Столички_ТВ'},
                {id: 17, name: 'Столички_ТВ'},
                {id: 18, name: 'Столички_ТВ'},
                {id: 19, name: '07_24_ТВ_Столички'},
                {id: 20, name: 'Столички_ТВ'},
                {id: 21, name: 'Столички_ТВ'},]
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        withPopper,
        copyKey: async function ($event) {
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText($event.target.textContent.trim());
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Ключ успешно скопирован' });
            }
        },
        loadTable: async function () {
            let response = await this.device.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selected_device_type
            );
            this.tbody = response.tbody;
            this.count = response.pages;
            if(this.page > 1 && this.tbody.length === 0)
            {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.$refs.devicesTable.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.loadTable();
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearchByNumberPharmacy: async function () {
            if (this.searchNumberPharmacy.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        onChangeDeviceType: async function (type_id) {
            this.selected_device_type = type_id;
            this.loadTable();
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types);
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        closeModal() {
            if (this.missingStore ===  '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите номер аптеки!' });
                return;
            }
            if (this.missingType ===  '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите тип устройства!' });
                return;
            }
            axios.post(this.route_device_missing, {
                store_number: this.missingStore,
                device_type: this.missingType
            });
            this.showModal = false;
            this.addAlert({ type: 'success', title: 'Успешно', text: 'Спасибо! Письмо успешно отправлено' });
        },
        closePlaylistAndGroupsModal() {
            this.showPlaylistsAndGroupsModal = false;
        },
        showPlaylistsModal() {
            this.modalTitle = 'Плейлисты, которые проигрываются на устройстве';
            this.modalItems = this.playlists;
            this.showPlaylistsAndGroupsModal = true;
        },
        showDeviceGroupsModal() {
            this.modalTitle = 'Группы, в которых участвует устройство';
            this.modalItems = this.deviceGroups;
            this.showPlaylistsAndGroupsModal = true;
        },
        validateMissingStore(){
            this.missingStore = this.missingStore.replace(/[^0-9-]/g, '');
        },
        showError() {
            this.$refs.Error.showError()
        },
        showWarning() {
            this.$refs.Warning.showWarning()
        },
        showSuccess() {
            this.$refs.Success.showSuccess()
        },
    },
    mounted() {
        this.loadTable();
        this.getDevicesTypesName();
    }
};
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}
.modal-container {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    input {
        z-index: 9999;
    }
    button {
        z-index: 9999;
    }
}
.modal-header {
    padding: 0px;
}
.modal-body {
    padding: 16px;
}
.modal-radio-btns {
    display: flex;
    flex-direction: column;
}
.modal-text {
    padding-bottom: 26px;
}
.modal-input {
    margin-bottom: 26px;
}
.a-modal {
    margin-left: auto;
}
.form-label {
    font-weight: 600;
}
.table-popup-btn {
    display: flex;
    gap: 6px;
    background-color: #F1F6FF;
    border-radius: 4px;
    padding: 4px 6px;
    cursor: pointer;
}
.filter-table {
    justify-content: flex-start;
}
.filter-table__item {
    display: flex;
    justify-content: center;
    align-items: center;
}
.filter-cancel-btn {
    cursor: pointer;
    color: #354052;
    transition: 0.2s;
}
.filter-cancel-btn:hover {
    color: red;
    transition: 0.2s;
}
</style>
